import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  NotificationManager,
} from "react-notifications";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { putAction } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  CustomSwitch,
  IntInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import { action as actionVar } from "variables/action";
import { fixedValuesByEnergy } from "variables/lists/action";
import RTProjectionsFluid from "./ProjectionsTable/RTProjections";

export default function ProjectionsEdit({
  apiData,
  params,
  closeModal,
  category,
}) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newProjections, setNewProjections] = useState({});
  const [totalsavingsmwh, setTotalsavingsmwh] = useState({});
  const [totalsavingsm3, setTotalsavingsm3] = useState({});
  const [totalsavingseuro, setTotalsavingseuro] = useState({});
  const [totalsavingsco2, setTotalsavingsco2] = useState({});
  const [totalproduction, setTotalproduction] = useState({});
  const [calculate, setCalculate] = useState(false);


  const handleInvestmentChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        projections: { ...prevState.parameters.projections, [name]: value },
      },
    }));
    setCalculate(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        projections: { ...prevState.parameters.projections, [name]: value },
      },
    }));
  };

  const handleCeeeligibilityChange = (e) => {
    const ceeeligibilityValue =
      newProjections?.[params]?.["ceeeligibility"] || false;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        projections: {
          ...prevState.parameters.projections,
          ceeeligibility: !ceeeligibilityValue,
        },
      },
    }));
  };

  useEffect(() => {
    setNewProjections(action?.parameters || {});
  }, [action]);

  useEffect(() => {
    setCalculate(true);
  }, []);

  useEffect(() => {
    if (calculate) {
      calculatetotal();
      setCalculate(false);
    }
  }, [calculate]);

  let url = putAction(action.id);

  const handleSubmit = async (event) => {
    axios
      .put(url, newProjections, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setAction((prevState) => ({
            ...prevState,
            parameters: newProjections,
          }));
          setNotification("success", "Projections modifées");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const prefill = () => {
    let projections = { ...action.parameters?.projections };
    if (action.parameters.general.category === "renewables") {
      let targetedenergy = action.parameters?.impact?.targetedenergy[0];
      if (targetedenergy) {
        targetedenergy.projectedfinalenergysavings = action.parameters?.impact?.savings[0]?.savingskwh / 1000;
        targetedenergy.projectedsavings = action.parameters?.impact?.savings[0]?.savingseuro;
        targetedenergy.projectedco2savings = action.parameters?.impact?.savings[0]?.savingsco2;
        targetedenergy.projectedproduction = action.parameters?.impact?.savings[0]?.production / 1000;
      }
      projections.investment = action.parameters?.impact?.savings[0]?.investment;
    } else if (
      action.parameters.general.category === "casing" ||
      action.parameters.general.category === "equipments"
    ) {
      if (action.parameters?.impact?.savings) {
        action.parameters.impact.savings.forEach((energy) => {
          let targetedenergy = action.parameters.impact.targetedenergy.find((obj) => obj.id === energy.energy);
          if (targetedenergy) {
            targetedenergy.projectedfinalenergysavings = energy.savingsvalue;
            targetedenergy.projectedsavings = fixedValuesByEnergy[energy.energy].euros * energy.savingsvalue;
            targetedenergy.projectedco2savings = fixedValuesByEnergy[energy.energy].co2 * energy.savingsvalue;
          }
        });
      }
      let invest = action.parameters.impact?.investment;
      projections.investment = invest;
    }
    else if (
      action.parameters.general.category === "behaviour"
    ) {
      if (action.parameters?.impact?.targetedenergy) {
        action.parameters.impact.targetedenergy.forEach((energy) => {
          energy.projectedfinalenergysavings = energy.earnings;
          energy.projectedsavings = fixedValuesByEnergy[energy.id].euros * energy.earnings;
          energy.projectedco2savings = fixedValuesByEnergy[energy.id].co2 * energy.earnings;
        });
      }
      let invest = action.parameters.impact?.investment;
      projections.investment = invest;
    }
    else if (
      action.parameters.general.category === "contracts"
    ) {
      let targetedenergy = action.parameters.impact.targetedenergy[0];
      if (targetedenergy) {
        let savingseuro = action.parameters.impact?.totalEarnings || 0.0;
        targetedenergy.projectedsavings = savingseuro;
        let savingsco2 = action.parameters.impact?.totalCo2 || 0.0;
        targetedenergy.projectedco2savings = savingsco2;
      }
      let invest = action.parameters.impact?.totalCost || 0;
      projections.investment = invest;
    }

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        projections: projections,
      },
    }));
    setCalculate(true);
  };

  console.log(action);

  const calculatetotal = () => {
    var totalsavingsmwhtmp = 0;
    var totalsavingsm3tmp = 0;
    var totalsavingseurostmp = 0;
    var totalsavingsco2tmp = 0;
    var totalproductiontmp = 0;
    if (action?.parameters?.impact?.targetedenergy) {
      action.parameters.impact.targetedenergy.forEach((energy) => {
        //console.log(energy);
        if (energy.projectedfinalenergysavings) {
          //console.log(energy.projectedfinalenergysavings);
          if (energy.id === 'water')
            totalsavingsm3tmp += Number(energy.projectedfinalenergysavings);
          else
            totalsavingsmwhtmp += Number(energy.projectedfinalenergysavings);
        }
        if (energy.projectedsavings) {
          totalsavingseurostmp += Number(energy.projectedsavings);
        }
        if (energy.projectedco2savings) {
          totalsavingsco2tmp += Number(energy.projectedco2savings);
        }
        if (energy.projectedproduction) {
          totalproductiontmp += Number(energy.projectedproduction);
        }
      });
    }
    setTotalsavingsmwh(totalsavingsmwhtmp);
    setTotalsavingsm3(totalsavingsm3tmp);
    setTotalsavingseuro(totalsavingseurostmp);
    setTotalsavingsco2(totalsavingsco2tmp);
    setTotalproduction(totalproductiontmp);

    let projections = { ...action.parameters?.projections };
    let monthlysavings = totalsavingseurostmp / 12;
    let roi = (projections.investment / monthlysavings).toFixed(2);
    projections.projectedroi = roi;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        projections: projections,
      },
    }));
  };

  return (
    <>
      {actionplanupdate && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={6}>
            <EditButton handleSubmit={prefill}>
              Préremplir avec les résultats d'impacts
            </EditButton>
          </GridItem>
        </GridContainer>
      )}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div
            style={{
              border: "0.099rem solid rgba(0, 0, 0, .22)",
              borderRadius: "0.3rem",
              padding: "0 0.6rem",
              margin: "0rem 0.5rem 0rem",
            }}
          >
            <RTProjectionsFluid
              setCalculate={setCalculate}
            />
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newProjections?.general?.category == "renewables" && (
            <IntInput
              inputTitle={actionVar[params]["totalproduction"]}
              intInput={totalproduction}
              name="totalproduction"
              disabled={true}
            />
          )}
          {newProjections?.general?.category !== "contracts" && (
            <IntInput
              inputTitle={actionVar[params]["totalsavingsmwh"]}
              intInput={totalsavingsmwh}
              name="totalsavingsmwh"
              disabled={true}
            />
          )}
          {(newProjections?.general?.category !== "contracts" || (newProjections?.general?.category === "contracts" && newProjections?.impact?.mode === "simple"))
            && (
              <IntInput
                inputTitle={actionVar[params]["totalsavingsco2"]}
                intInput={totalsavingsco2}
                name="totalsavingsco2"
                disabled={true}
              />
            )}
          <IntInput
            inputTitle={actionVar[params]["investment"]}
            intInput={newProjections?.[params]?.["investment"] || ""}
            handleIntInputChange={handleInvestmentChange}
            name="investment"
            disabled={!actionplanupdate}
          />
          <IntInput
            inputTitle={actionVar[params]["projectedroi"]}
            intInput={newProjections?.[params]?.["projectedroi"] || ""}
            handleIntInputChange={handleChange}
            name="projectedroi"
            disabled={true}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newProjections?.general?.category !== "contracts" && (
            <IntInput
              inputTitle={actionVar[params]["totalsavingsm3"]}
              intInput={totalsavingsm3}
              name="totalsavingsm3"
              disabled={true}
            />
          )}
          <IntInput
            inputTitle={actionVar[params]["totalsavingseuro"]}
            intInput={totalsavingseuro}
            name="totalsavingseuro"
            disabled={true}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          {newProjections?.general?.category !== "contracts" && (
            <CustomSwitch
              style={{ "margin": "1.3rem 0rem 0rem 1rem" }}
              inputTitle={actionVar[params]["ceeeligibility"]}
              checkedState={newProjections?.[params]?.["ceeeligibility"] || false}
              handleSwitchChange={handleCeeeligibilityChange}
              name="ceeeligibility"
              disabled={!actionplanupdate}
            />)}
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newProjections?.[params]?.["ceeeligibility"] === true && (
            <IntInput
              inputTitle={actionVar[params]["ceecumac"]}
              intInput={newProjections?.[params]?.["ceecumac"] || ""}
              handleIntInputChange={handleChange}
              name="ceecumac"
              disabled={!actionplanupdate}
            />
          )}
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newProjections?.[params]?.["ceeeligibility"] === true && (
            <IntInput
              inputTitle={actionVar[params]["ceeeuros"]}
              intInput={newProjections?.[params]?.["ceeeuros"] || ""}
              handleIntInputChange={handleChange}
              name="ceeeuros"
              disabled={!actionplanupdate}
            />
          )}
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
